import api from './api';

/**
 * Promo Codes admin API.
 *
 * Routes through the shared `api` axios instance (baseURL = REACT_APP_API_URL +
 * '/admin'), so the 401-refresh interceptor applies. Paths are passed WITHOUT
 * the `/admin` prefix; `/promo-codes` resolves to `/api/admin/promo-codes`.
 *
 * GET is staff-readable; all mutations are owner-only (enforced server-side).
 */

export interface PromoCode {
  id: number;
  shop_id: number;
  code: string;
  discount_type: 'percentage' | 'amount';
  discount_value: number;
  max_uses: number | null; // null = unlimited
  used_count: number;
  starts_at: string | null;
  ends_at: string | null;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface CreatePromoCodeInput {
  code: string;
  discount_type: 'percentage' | 'amount';
  discount_value: number;
  max_uses?: number | null;
  starts_at?: string | null;
  ends_at?: string | null;
  is_active?: boolean;
}

export interface UpdatePromoCodeInput {
  code?: string;
  discount_type?: 'percentage' | 'amount';
  discount_value?: number;
  max_uses?: number | null;
  starts_at?: string | null;
  ends_at?: string | null;
  is_active?: boolean;
}

export const getPromoCodes = async (): Promise<PromoCode[]> => {
  const response = await api.get('/promo-codes');
  return response.data;
};

export const createPromoCode = async (input: CreatePromoCodeInput): Promise<PromoCode> => {
  const response = await api.post('/promo-codes', input);
  return response.data;
};

export const updatePromoCode = async (
  id: number,
  input: UpdatePromoCodeInput,
): Promise<PromoCode> => {
  const response = await api.put(`/promo-codes/${id}`, input);
  return response.data;
};

export const deletePromoCode = async (id: number): Promise<void> => {
  await api.delete(`/promo-codes/${id}`);
};
